import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { formsTemplatesTranslationKeys } from '../translations';

export const FormsTemplatesListNoSearchResultsEmptyStatePlaceholder = (): JSX.Element => {
   return <EmptyStatePlaceholder testId={'noSearchResults'} heading={formsTemplatesTranslationKeys.noSearchResults} />;
};
